
<p-accordion [multiple]="true">
  <p-accordionTab
    header="{{ 'Common.Form.Header' | translate }}"
    [(selected)]="isSearchFormOpen">
  <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
  </p-accordionTab>

  <p-accordionTab
    header="{{ 'ForwarderSetting.RMBRecommendForwarder.FormHeader.DataTable' | translate }}"
    [(selected)]="isDataTableOpen">
    <ng-content *ngTemplateOutlet="settingDataTableTemplate"></ng-content>
  </p-accordionTab>
</p-accordion>

<ng-template #settingSearchFormTemplate>
  <form [formGroup]="searchForm">
    <div class="p-fluid formgrid grid">
        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'BookingSearch.Form.Forwarder' | translate }}</label>
          <div class="item">
            <p-multiSelect
              formControlName="forwarderCodeList"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [options]="forwarderOptions"
              [filter]="true"
              filterBy="label">
            </p-multiSelect>
          </div>
        </div>
      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'BookingSearch.Form.LetterHead' | translate }}</label>
        <p-multiSelect
          formControlName="letterHeadOrgIdList"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [options]="letterOrgIdOptions"
          [filter]="true"
          filterBy="label"
        ></p-multiSelect>
      </div>
      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'ForwarderSetting.RMBRecommendForwarder.TableColumn.WorkingDay' | translate }}</label>
        <p-dropdown
          formControlName="workingDay"
          [filter]="true"
          [options]="workingDayOptions"
          [showClear]="true"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
        ></p-dropdown>
      </div>
      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'ReceivingRegistration.MainTable.Brand' | translate }}</label>
        <div class="item">
        <p-dropdown
          formControlName="brand"
          [filter]="true"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          [options]="brandOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [itemSize]="40"
          [filter]="true"
          styleClass="p-text-left">
        </p-dropdown>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col">
        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick()" class="p-button-secondary ml-2"></button>
        <button pButton pRipple label="{{ 'Common.Button.Import' | translate }}" icon="pi pi-upload" (click)="showImportDialog()" class="p-mr-2"></button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #settingDataTableTemplate>
  <div class="mt-2">
    <laas-data-table
      #dataTable
      [loading]="isLoading"
      [tableKey]="preferenceKey"
      [defaultColumns]="columns"
      [value]="dataRows"
      [lazy]="true"
      [editPermission]="editPermissionCode"
      [dataKey]="'rowId'"
      [selectable]="true"
      [(selectedRows)]="selectedRows"
      [createNewRow]="createNewRow"
      [inputValid]="dataInputValid"
      (createRow)="createRow($event)"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      (savedData)="saveData($event)"
    >
      <ng-template pTemplate="caption">
        <ng-container *ngIf="dataTable.isEdit">
          <button
            pButton
            type="button"
            label="{{ 'Common.Button.Delete' | translate }}"
            icon="fas fa-trash-alt"
            [disabled]="!dataTable.isInEditMode"
            (click)="deleteBtnClick()"
            class="p-button-danger p-button-raised p-ml-2">
          </button>
          <button
            pButton
            pRipple
            label="{{ 'Common.Button.Export' | translate }}"
            [disabled]="dataRows.length === 0"
            (click)="exportBtnClick()"
            class="p-ml-2">
          </button>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith:'-'}}
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'letterHeadOrgId'">
              {{ rowData[col.field] | optionsMapping:letterOrgIdOptions |replaceNullWith:'-'}}
            </ng-container>
            <ng-container *ngSwitchCase="'forwarderCode'">
              {{ rowData[col.field] | optionsMapping:forwarderOptions |replaceNullWith:'-'}}
            </ng-container>
            <ng-container *ngSwitchCase="'brand'">
              {{ rowData[col.field] | optionsMapping:brandOptions |replaceNullWith:'-'}}
            </ng-container>
            <ng-container *ngSwitchCase="'consigneeKey'">
              {{ rowData[col.field] | optionsMapping:consigneeKeyOptions |replaceNullWith:'-'}}
            </ng-container>
            <ng-container *ngSwitchCase="'pickupLocationCode'">
              {{ rowData[col.field] | optionsMapping:pickupLocationCodeOptions |replaceNullWith:'-'}}
            </ng-container>
            <ng-container *ngSwitchCase="'createUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
      <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div [ngSwitch]="col.dataType">
              <ng-container *ngSwitchCase="'date'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith:'-'}}
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'letterHeadOrgId'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="letterOrgIdOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="forwarderOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'workingDay'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate }}"
              [options]="workingDayOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'brand'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [itemSize]="40"
              [showClear]="true"
              [options]="brandOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
            <laas-customer-dropdown
              [(ngModel)]="rowData[col.field]"
              [isSingle]="true"
              [divClass]="'p-fluid'"
              (onDataLoaded)="onCustomerListLoaded($event)"
              (onOptionDataChange)="onTableConsigneeChange($event, rowData)">
          </laas-customer-dropdown>
          </ng-container>
          <ng-container *ngSwitchCase="'inHouseNo'" class="p-fluid">
            <input [(ngModel)]="rowData[col.field]" pInputText type="text"/>
          </ng-container>
          <ng-container *ngSwitchCase="'pickupLocationCode'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : pickupLocationCodeOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [showClear]="true"
              [options]="pickupLocationCodeOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div [ngSwitch]="col.dataType">
              <ng-container *ngSwitchCase="'date'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith:'-'}}
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'letterHeadOrgId'">
            {{ rowData[col.field] | optionsMapping:letterOrgIdOptions |replaceNullWith:'-'}}
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'">
            {{ rowData[col.field] | optionsMapping:forwarderOptions |replaceNullWith:'-'}}
          </ng-container>
          <ng-container *ngSwitchCase="'brand'">
            {{ rowData[col.field] | optionsMapping:brandOptions |replaceNullWith:'-'}}
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'">
            {{ rowData[col.field] | optionsMapping:consigneeKeyOptions |replaceNullWith:'-'}}
          </ng-container>
          <ng-container *ngSwitchCase="'pickupLocationCode'">
            {{ rowData[col.field] | optionsMapping:pickupLocationCodeOptions |replaceNullWith:'-'}}
          </ng-container>
          <ng-container *ngSwitchCase="'createUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>

<p-dialog header="Rmb貨代批次匯入" [(visible)]="displayImportDialog" [style]="{width: '50vw'}" [modal]="true" [baseZIndex]="100">

  <div *ngIf="isImportDialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="p-fluid">
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ForwarderSetting.UploadDailog.ImportFacility' | translate }}</label>
      <p-multiSelect
          [filter]="true"
          [options]="facilityOptions"
          [(ngModel)]="facilityList"
          [appendTo]="'body'"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
      </p-multiSelect>
    </div>
    <div class="flex justify-content-between">
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xls,.xlsx,.xlsm">
      <button pButton pRipple label="{{ 'Common.Button.Select' | translate }}" icon="pi pi-check" class="p-button-success mr-2" (click)="fileInput.click()"></button>
      <button pButton pRipple label="{{ 'Common.Button.FileUpload' | translate }}" icon="pi pi-upload" class="mr-2" (click)="uploadFile()" [disabled]="!isFileSelected"></button>
      <button pButton pRipple label="{{ 'Common.Button.DownloadTemplate' | translate }}" icon="pi pi-download" class="p-button-secondary" (click)="downloadTemplateBtn()"></button>
    </div>

    <div *ngIf="isFileSelected" class="mt-3">
      File: {{ selectedFileName }}
    </div>
  </div>
</p-dialog>
